import {useEffect, useState} from 'react';
import {Navigate, Outlet} from 'react-router-dom';

import {getMe} from '@/api/internal/user/user-api';
import PreLoading from '@/components/common/PreLoading';
import {useAuthStore} from '@/store/authStore';

const PrivateRoute = () => {
  const [loading, setLoading] = useState(true);
  const {user, hydrated, setFromMe, refreshToken} = useAuthStore();

  useEffect(() => {
    if (hydrated && user) {
      setLoading(false);
      return;
    }

    const checkAuth = async () => {
      try {
        try {
          console.log('첫 번째 getMe() 시도');
          const me = await getMe();

          if (me && me.user) {
            console.log('getMe() 성공, 사용자 정보 있음:', me);
            setFromMe(me);
            setLoading(false);
            return;
          } else {
            console.log('getMe() 응답은 성공이지만 사용자 정보 없음:', me);
          }
        } catch (error) {
          console.log('getMe() 호출 자체가 실패:', error);
        }

        console.log('refresh 토큰으로 갱신 시도');
        const refreshSuccess = await refreshToken();
        console.log('refresh 결과:', refreshSuccess);

        if (refreshSuccess) {
          try {
            console.log('refresh 후 getMe() 재시도');
            const me = await getMe();

            if (me && me.user) {
              console.log('refresh 후 getMe() 성공:', me);
              setFromMe(me);
              setLoading(false);
              return;
            } else {
              console.log('refresh 후에도 사용자 정보 없음:', me);
            }
          } catch (error) {
            console.log('refresh 후 getMe() 실패:', error);
          }
        }

        console.log('모든 인증 시도 실패, 로그아웃 상태로 설정');
        setFromMe(null);
        setLoading(false);
      } catch (error) {
        console.error('인증 확인 중 오류:', error);
        setFromMe(null);
        setLoading(false);
      }
    };

    checkAuth();
  }, [hydrated, user, setFromMe, refreshToken]);

  if (loading) return <PreLoading />;

  const isAuthenticated = !!user;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
